import { useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Product } from '../types';
import { useStore } from '../store/useStore';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface ProductCardProps {
  product: Product;
}

export function ProductCard({ product }: ProductCardProps) {
  const navigate = useNavigate();
  const addToCart = useStore(state => state.addToCart);

  const handleAddToCart = (e: React.MouseEvent) => {
    e.stopPropagation();
    addToCart(product);
  };

  return (
    <Card
      className="overflow-hidden cursor-pointer transition-transform active:scale-[0.98]"
      onClick={() => navigate(`/product/${product.id}`)}
    >
      <div className="relative aspect-square bg-secondary flex items-center justify-center">
        {product.imageUrl ? (
          <img
            src={product.imageUrl}
            alt={product.name}
            className="w-full h-full object-contain p-4"
          />
        ) : (
          <ShoppingCart className="w-12 h-12 text-muted-foreground" />
        )}
        {product.stock < 5 && product.stock > 0 && (
          <span className="absolute top-2 right-2 bg-orange-500 text-white text-xs font-semibold px-2 py-1 rounded-md">
            Осталось {product.stock}
          </span>
        )}
        {product.stock === 0 && (
          <span className="absolute top-2 right-2 bg-gray-500 text-white text-xs font-semibold px-2 py-1 rounded-md">
            Нет в наличии
          </span>
        )}
      </div>

      <CardContent className="p-3">
        <h3 className="font-semibold text-sm truncate">{product.name}</h3>
        <p className="text-xs text-muted-foreground line-clamp-2 min-h-[2.5rem] mt-1">
          {product.description}
        </p>

        <div className="flex items-center justify-between mt-3">
          <span className="text-lg font-bold text-primary">{product.price} ₽</span>
          <Button
            size="icon"
            variant="default"
            onClick={handleAddToCart}
            disabled={product.stock === 0}
            className="rounded-full h-9 w-9"
          >
            <ShoppingCart className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
